export enum TrendPeriodEnum {
    Minutes = 1,
    Hours,
    Days
}